import React from 'react';
import {startOfTomorrow} from "date-fns";
import {Loading, Toast, Divider, Button} from "spectre-react/dist/cjs";
import WagesParamsForm from "./WagesParamsForm";
import {fetchWagesParamsLast, postWagesParams} from "../../api";
import {isoFmt} from "../shared/utils";
import {Redirect} from "react-router-dom";
import {SETTINGS_PATH} from "../../paths";


class WagesParamsEditPage extends React.Component {
    state = {
        fetchState: 0, fetchError: undefined,
        submitState: 0, submitError: undefined,
        calcParams: undefined,
        startDate: undefined,
        action: undefined,
    }

    _paramsFormController = undefined;
    receiveController = (controller) => this._paramsFormController = controller;

    componentDidMount() {
        this.fetchData();
    }

    fetchData = async () => {
        this.setState({fetchState: 1, fetchError: undefined});

        try {
            const {doc, action} = await fetchWagesParamsLast();

            const tomorrowISO = isoFmt(startOfTomorrow());
            const startDate = action === "add" ? tomorrowISO : doc.startDate;

            this.setState({fetchState: 2, startDate, action, calcParams: doc.params});
        } catch (error) {
            console.error(error);
            this.setState({fetchState: 0, fetchError: error.message});
        }
    }

    onSubmit = async () => {
        const {startDate, params} = this._paramsFormController.getParams();

        this.setState({submitState: 1, submitError: undefined});

        try {
            await postWagesParams({startDate, params});
            this.setState({submitState: 2});
        } catch (error) {
            console.error(error);
            this.setState({submitState: 0, submitError: error.message});
        }
    }

    render() {
        const {fetchState, fetchError, submitState, submitError, calcParams, startDate, action} = this.state;

        if (submitState === 2) {
            alert("Изменения успешно внесены.");
            return <Redirect to={SETTINGS_PATH} />;
        }

        if (fetchError)
            return <Toast error>{fetchError}</Toast>;

        if (fetchState !== 2)
            return <Loading large/>;

        return (
            <div>
                <div className="h2">Редактирование коэффициентов ОТ</div>

                {action === "add" && <p>Будет создан новый набор коэффициентов. Обратите внимание, что дата начала не может быть раньше завтрашнего дня.</p>}
                {action === "edit" && <p>Будет отредактированы коэффициенты, которые еще не начали действовать. Обратите внимание, что дата начала в любом случае не может быть раньше завтрашнего дня.</p>}

                <Divider />

                <WagesParamsForm calcParams={calcParams} startDate={startDate} provideController={this.receiveController} />

                <Divider />

                <div>
                    {submitError && <Toast error className="my-2">{submitError}</Toast>}

                    <Button primary loading={submitState === 1} onClick={this.onSubmit}>Отправить</Button>
                </div>
            </div>
        );
    }
}


export default WagesParamsEditPage;